import React, { useState } from "react";
import logo from "../photos/Luksiwag.svg"; // Adjust the path if needed
import "../styles/styles.css";
import AddRecord from "./AddRecord";
import ShowRecord from "./ShowRecord";
import ShowFolder from "./ShowFolder";
import ShowCalendar from "./ShowCalendar";

const MainPage = ({ token }) => {
  const [selectedView, setSelectedView] = useState(null);

  return (
    <div className="main-container">
      {/* Header Section */}
      <header className="header">
        <img src={logo} alt="Logo" className="logo" />
        <h1 className="app-name">Wiczka WebApp</h1>
      </header>

      <div className="content">
        {/* Sidebar Menu */}
        <nav className="sidebar">
          <button onClick={() => setSelectedView("addRecord")}>Dodaj Świadectwa</button>
          <button onClick={() => setSelectedView("showRecord")}>Lista Świadectw</button>
          <button onClick={() => setSelectedView("showFolder")}>Lista Plików Swiadectw</button>
          <button onClick={() => setSelectedView("showCalendar")}>Kalendarz</button>
        </nav>

        {/* Main Content Area */}
        <main className="main-content">
          {selectedView === "addRecord" ? (
            <AddRecord token={token} />
          ) : selectedView === "showRecord" ? (
            <ShowRecord token={token} />
          ) : selectedView === "showFolder" ? (
            <ShowFolder token={token} />
          ) : selectedView === "showCalendar" ? (
            <ShowCalendar token={token} />
          ) : (
              <h2>{selectedView || "Wybierz opcję"}</h2>
            )}
        </main>
      </div>
    </div>
  );
};

export default MainPage;
